import React, { useContext } from 'react';
import {
  DetailContext,
  DetailHandle,
  PrimaryDetailActionbarButton,
  SecondaryDetailActionbarButton,
  UserContext,
} from '@eas/common-web';
import { DetailActionButton } from '@components/action-button/detail-action-button';
import { Loan } from '@models';
import { LoanState, Role } from '@enums';
import { cancelLoan, returnLoan } from './loan-api';

export function ActionBar() {
  const { source } = useContext<DetailHandle<Loan>>(DetailContext);
  const { hasPermission } = useContext(UserContext);
  const show =
    source.data?.state === LoanState.ACTIVE &&
    (hasPermission(Role.FILE_ROOM) || hasPermission(Role.SUPERADMIN));

  if (!show || !source.data?.id) return null;

  return (
    <>
      <DetailActionButton
        promptKey="RETURN_LOAN"
        apiCall={() => returnLoan(source.data!.id!)}
        buttonLabel="Vrátit"
        dialogTitle="Vrácení zápůjčky"
        dialogText="Skutečně chcete vrátit zápůjčku?"
        ButtonComponent={PrimaryDetailActionbarButton}
      />
      <DetailActionButton
        promptKey="CANCEL_LOAN"
        apiCall={() => cancelLoan(source.data!.id!)}
        buttonLabel="Stornovat"
        dialogTitle="Storno zápůjčky"
        dialogText="Skutečně chcete stornovat zápůjčku?"
        ButtonComponent={SecondaryDetailActionbarButton}
      />
    </>
  );
}
